import React, { Component } from "react";
import { connect } from "react-redux";
import Formsy from "formsy-react";

import { Modal, Button, Glyphicon } from "react-bootstrap";

import {
    hideUserModal,
    changeRole,
    fetchSanitaryBook,
    reviewSanitaryBook,
} from "../userDetails.actions";
import {
    addUserByApi,
    updateUserByApi,
    checkUser,
    checkEmail,
    checkTerminalId,
    getTerminalId,
    getNewDistributorList,
} from "../../Admin/admin.actions";
import FooterButtons from "../../../components/common/elements/FooterButtons";
import EditableField from "./EditableField";
import SelectRole from "./SelectRole";
import SanitaryBook from "./SanitaryBook";
import translator from "../../../components/localization/translator";
import rolesConf from "../../../config/roles";
import Notifier from "../../../components/message/Notifier";
import { ENTER_KEY, USER_ROLES, DISTRIBUTOR_TERMINAL_TYPES } from "../../../config/constants";
import security from "../../../components/common/security/security";

class UserDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isDisabled: true,
            disabled: false,
            jksFile: null,
            certPassword: "",
            forceJksReplace: false,
            hasJksAttachedByUserId: {},
        };

        this.changedData = {};
        this.isNew = false;
        this.enableButton = this.enableButton.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.disableButtonForTarrif = this.disableButtonForTarrif.bind(this);
        this.enableButtonForTarrif = this.enableButtonForTarrif.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.jksInputRef = React.createRef();
    }

    onJksPickClick() {
        if (this.jksInputRef && this.jksInputRef.current) {
            this.jksInputRef.current.click();
        }
    }

    onJksFileChange(e) {
        const file = e && e.target && e.target.files && e.target.files[0] ? e.target.files[0] : null;
        if (!file) {
            this.setState({ jksFile: null });
            return;
        }

        const name = String(file.name || "");
        const ext = name.includes(".") ? name.split(".").pop().toLowerCase() : "";
        const allowed = ["jks", "p12"];
        if (!allowed.includes(ext)) {
            Notifier.warning("_something_went_wrong_");
            if (this.jksInputRef && this.jksInputRef.current) {
                this.jksInputRef.current.value = "";
            }
            this.setState({ jksFile: null });
            return;
        }

        this.setState({ jksFile: file });
    }

    setChangedData(key, value) {
        this.changedData[key] = value;
    }

    getUserData() {
        const user = this.props.userDetails.user;
        const role = this.props.userDetails.changedRole || user.role;
        const userColumns = rolesConf.user.getByRole(role);
        const changedData = this.changedData;
        const userData = {};
        for (let i in userColumns) {
            if (userColumns[i].canChange) {
                const key = userColumns[i].key;
                const value = changedData.hasOwnProperty(key) ? changedData[key] : this.props.userDetails.user[key];
                userData[key] = value;
            }
        }
        if (changedData.hasOwnProperty("distributionPartner")) {
            userData.distributionPartner = changedData.distributionPartner;
        }
        if (changedData.hasOwnProperty("areaName")) {
            userData.areaName = changedData.areaName;
        }
        if (userData.hasOwnProperty("posTerminalType") && userData.posTerminalType === undefined) {
            userData.posTerminalType = DISTRIBUTOR_TERMINAL_TYPES.standard.id;
        }

        // if (changedData.hasOwnProperty("tariffChanged") && role == USER_ROLES.DISTRIBUTOR) {
        //     const tariff = this.props.tariffDetails.tariffList.find(e => e._id == changedData.tariff);
        //     if (tariff && tariff.name != this.props.userDetails.user.tariff) {
        //         userData.tariffChanged = changedData.tariffChanged;
        //     }
        // }
        if (changedData.hasOwnProperty("type") && role == USER_ROLES.DISTRIBUTOR) {
            userData.type = changedData.type;
        }
        if (userData.hasOwnProperty("extra")) {
            if (!userData.extra) {
                userData.extra = [];
            } else {
                userData.extra = userData.extra.filter(e => e.partner);
            }
        }
        userData.role = role;
        return userData;
    }

    save() {
        const user = this.getUserData();
        user.name = user.name.trim();

        const { jksFile, certPassword } = this.state;
        const isSuperAdmin = security.getUser() && security.getUser().role === USER_ROLES.SUPER_ADMIN;
        const shouldSendJks = Boolean(isSuperAdmin && jksFile);

        // Define fields that should never be sent to the API
        const EXCLUDED_FIELDS = ['temporaryPassword'];

        const payload = shouldSendJks
            ? (() => {
                const form = new FormData();
                Object.keys(user || {}).forEach((key) => {
                    const v = user[key];
                    // Skip the field if value is undefined, null, or in excluded list
                    if (v === undefined || v === null || EXCLUDED_FIELDS.includes(key)) {
                        return;
                    }
                    form.append(key, typeof v === "boolean" ? String(v) : v);
                });
                form.append("certPassword", certPassword || "");
                form.append("certificate", jksFile);
                return form;
            })()
            : (() => {
                // Create a new object without the excluded fields
                const filteredUser = {};
                Object.keys(user).forEach((key) => {
                    if (!EXCLUDED_FIELDS.includes(key) && user[key] !== undefined && user[key] !== null) {
                        filteredUser[key] = user[key];
                    }
                });
                return filteredUser;
            })();

        const afterSave = () => {
            Notifier.success(
                this.isNew ? "_user_successfully_added_" : "_user_successfully_updated_",
                "_user_updated_",
            );
            const currentId = this.props.userDetails?.user?._id;
            // preserve pagination + filters from Distributors state (via window) – keep current page/filters after save, but refresh clears filters (window state reset)
            try {
                const winState = window.__distributorsState;
                if (winState && (winState.filters || winState.page)) {
                    const payload = {};
                    if (winState.page) payload.page = winState.page;
                    if (winState.sizePerPage) payload.pageSize = winState.sizePerPage;
                    Object.keys(winState.filters || {}).forEach(k => {
                        const v = winState.filters[k];
                        if (v != null && String(v).trim() !== "") payload[k] = v;
                    });
                    // fallback pagination from URL if not in window
                    if (!payload.page || !payload.pageSize) {
                        const params = new URLSearchParams(window.location.search);
                        const page = parseInt(params.get("page"), 10);
                        const pageSize = parseInt(params.get("pageSize") || params.get("sizePerPage"), 10);
                        if (!Number.isNaN(page) && page > 0 && !payload.page) payload.page = page;
                        if (!Number.isNaN(pageSize) && pageSize > 0 && !payload.pageSize) payload.pageSize = pageSize;
                    }
                    this.props.getNewDistributorList(payload);
                } else {
                    const params = new URLSearchParams(window.location.search);
                    const payload = {};
                    const page = parseInt(params.get("page"), 10);
                    const pageSize = parseInt(params.get("pageSize") || params.get("sizePerPage"), 10);
                    if (!Number.isNaN(page) && page > 0) payload.page = page;
                    if (!Number.isNaN(pageSize) && pageSize > 0) payload.pageSize = pageSize;
                    if (Object.keys(payload).length) {
                        this.props.getNewDistributorList(payload);
                    } else {
                        this.props.getNewDistributorList();
                    }
                }
            } catch {
                this.props.getNewDistributorList();
            }

            this.setState((prev) => ({
                jksFile: null,
                certPassword: "",
                forceJksReplace: false,
                hasJksAttachedByUserId: (shouldSendJks && currentId)
                    ? { ...prev.hasJksAttachedByUserId, [currentId]: true }
                    : prev.hasJksAttachedByUserId,
            }));
            this.cancel();
        };
        if (this.isNew) {
            this.props.addUserByApi(payload, afterSave);
        } else {
            const id = this.props.userDetails.user._id;
            const role = this.props.userDetails.user.role;
            this.props.updateUserByApi(id, role, payload, afterSave);
        }
    }

    cancel() {
        this.changedData = {};
        this.setState({ jksFile: null, certPassword: "", forceJksReplace: false });
        this.props.hideUserModal();
    }

    renderJksSection(user) {
        const currentUser = security.getUser();
        const isSuperAdmin = currentUser && currentUser.role === USER_ROLES.SUPER_ADMIN;
        if (!isSuperAdmin) return null;

        const role = this.props.userDetails.changedRole || user.role;
        if (role !== USER_ROLES.DISTRIBUTOR) return null;

        const locallyAttached = Boolean(this.state.hasJksAttachedByUserId && this.state.hasJksAttachedByUserId[user?._id]);
        const hasJks = Boolean(
            user && (user.p12_file || user.p12File),
        ) || locallyAttached;

        const { jksFile, forceJksReplace } = this.state;
        const showPicker = forceJksReplace || !hasJks || !jksFile;
        const { hasCertificate } = user

        return (
            <div style={{ marginTop: 15 }}>
                <div className="display-flex" style={{ gap: 10 }}>
                    <div style={{ display: "flex", alignItems: "center", minWidth: 250, fontWeight: 600, gap: 10 }}>
                        .p12
                        {hasCertificate && (
                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                <Glyphicon glyph="ok" style={{ color: "green" }} />
                                <span style={{ color: "green", fontWeight: 600 }}>Կցված է</span>
                            </div>
                        )}
                    </div>
                    <div style={{ flex: 1, display: "flex", justifyContent: "start", gap: 12 }}>
                        {(showPicker || hasCertificate) && (
                            <div style={{ display: "block", alignItems: "center", gap: 10 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                    <input
                                        ref={this.jksInputRef}
                                        type="file"
                                        accept=".jks,.p12"
                                        style={{ display: "none" }}
                                        onChange={this.onJksFileChange.bind(this)}
                                    />
                                    <Button bsStyle="default" onClick={this.onJksPickClick.bind(this)}>
                                        {jksFile ? "Փոխարինել ֆայլը" : "Կցել ֆայլ"}
                                    </Button>
                                    {jksFile ? (
                                        <span style={{ fontStyle: "italic" }}>{jksFile.name}</span>
                                    ) : null}
                                </div>

                                <div>
                                    {jksFile && (
                                        <div style={{ marginTop: 10, maxWidth: 320 }}>
                                            <label style={{ display: "block" }}>{translator.translate("_password_")}</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                value={this.state.certPassword}
                                                onChange={(e) => this.setState({ certPassword: e.target.value })}
                                                placeholder=""
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    renderSanitaryBookSection(user) {
        if (this.isNew || (this.props.userDetails.changedRole || user.role) !== USER_ROLES.DISTRIBUTOR) {
            return null;
        }
        return (
            <SanitaryBook
                distributorId={user._id}
                onFetchSanitaryBook={this.props.fetchSanitaryBook}
                onReview={this.props.reviewSanitaryBook} />
        );
    }

    renderFooter() {
        return (
            <Modal.Footer>
                <FooterButtons
                    cancelButton={translator.translate("_cancel_")}
                    saveButton={translator.translate("_save_")}
                    save={this.save.bind(this)}
                    cancel={this.cancel.bind(this)}
                    isDisabled={this.state.isDisabled || this.state.disabled} />
            </Modal.Footer>
        );
    }

    enableButton() {
        this.setState({ isDisabled: false });
    }

    disableButton() {
        this.setState({ isDisabled: true });
    }

    disableButtonForTarrif() {
        if (!this.state.isDisabled) {
            this.setState({ isDisabled: true });
        }
    }

    enableButtonForTarrif() {
        if (this.state.isDisabled) {
            this.setState({ isDisabled: false });
        }
    }

    handleKeyPress(event) {
        if (event.charCode === ENTER_KEY.keyCode) {
            if (!this.state.isDisabled && !this.state.disabled) {
                this.save();
            }
            return;
        }
    }

    handleBlur(key, value) {
        if (key === "username") {
            if (!this.isNew && value === this.props.userDetails.user.username) {
                return this.setState({ disabled: false });
            }
            this.setState({ disabled: true });
            this.props.checkUser(value, (data) => {
                if (data.userExist) {
                    Notifier.error("_user_already_exists_");
                } else {
                    this.setState({ disabled: false });
                }
            });
        } else if (key === "email") {
            if (!this.isNew && value === this.props.userDetails.user.email) {
                return this.setState({ disabled: false });
            }
            this.setState({ disabled: true });
            this.props.checkEmail(value, (data) => {
                if (data.emailExist) {
                    Notifier.error("_email_already_exists_");
                } else {
                    this.setState({ disabled: false });
                }
            });
        } else if (key === "terminalId") {
            if (!this.isNew && Number(value) === this.props.userDetails.user.terminalId) {
                return this.setState({ disabled: false });
            }
            this.setState({ disabled: true });
            this.props.checkTerminalId(value, (data) => {
                if (data.terminalIdExist) {
                    Notifier.error("_terminal_id_already_exists_");
                } else {
                    this.setState({ disabled: false });
                }
            });
        }
    }

    getDefaultType(role) {
        const types = rolesConf.user.getTypes(role);
        for (let i = 0, length = types.length; i < length; i++) {
            if (types[i].isDefault) {
                return types[i].id;
            }
        }
    }

    updateType(type) {
        const changedData = this.changedData.type = type;
        changedData.type = type;
        this.changedData = changedData;
    }

    render() {
        const user = this.props.userDetails.user;
        const distributionPartners = this.props.distributionPartners || {};
        if (!user) {
            return null;
        }
        this.isNew = !user.role;

        return (
            <Modal
                bsSize="large"
                show={this.props.userDetails.show}
                onHide={this.cancel.bind(this)}
                onKeyPress={this.handleKeyPress}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {translator.translate("_user_details_")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="scrollable modal-possition">
                    <Formsy onValid={this.enableButton} onInvalid={this.disableButton}>
                        <EditableField
                            name="UserEditableFields"
                            userDetails={this.props.userDetails}
                            partners={(this.props.partners || []).filter(partner => !partner.deleted)}
                            setChangedData={this.setChangedData.bind(this)}
                            isNew={this.isNew}
                            onBlur={this.handleBlur}
                            tariffs={this.props.tariffDetails?.tariffList || []}
                            areas={this.props.areaDetails?.areaList || []}
                            apiUsers={this.props.users?.find(item => +item.role === USER_ROLES.API_USER) || { users: [] }}
                            distributionPartners={(distributionPartners || {}).users || []}
                            getTerminalId={this.props.getTerminalId}
                            disableButton={this.disableButtonForTarrif}
                            enableButton={this.enableButtonForTarrif}
                        />
                        {this.renderJksSection(user)}
                        {this.renderSanitaryBookSection(user)}
                        <SelectRole
                            userDetails={this.props.userDetails}
                            changeRole={this.props.changeRole}
                            isNew={this.isNew} />
                    </Formsy>
                </Modal.Body>
                {this.renderFooter()}
            </Modal>
        );
    }
};

let mapStateToProps = (state) => {
    return {
        partners: state.restaurants,
        userDetails: state.userDetails,
        tariffDetails: state.tariffDetails,
        areaDetails: state.areaDetails,
        users: state.users,
        distributionPartners: state.users.find(user => user.role === USER_ROLES.DISTRIBUTION_PARTNER),
    };
};

export default connect(
    mapStateToProps,
    {
        hideUserModal,
        updateUserByApi,
        addUserByApi,
        changeRole,
        checkUser,
        checkEmail,
        checkTerminalId,
        getTerminalId,
        getNewDistributorList,
        fetchSanitaryBook,
        reviewSanitaryBook,
    },
)(UserDetails);
